"use client";

import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import React from "react";

type AppButtonVariant =
  | "primary"
  | "secondary"
  | "danger"
  | "outline-primary"
  | "outline-secondary"
  | "search";

interface AppButtonProps extends Omit<ButtonProps, "variant"> {
  variant?: AppButtonVariant;
  // Adds flex row layout with icon gap — for trigger/action buttons in page headers
  action?: boolean;
}

// The visual definitions live in buttonVariants (components/ui/button.tsx);
// this only maps the app-facing names onto them.
const variantMap: Record<
  AppButtonVariant,
  NonNullable<ButtonProps["variant"]>
> = {
  primary: "primary",
  secondary: "secondaryAction",
  danger: "danger",
  search: "search",
  "outline-primary": "outline-primary",
  "outline-secondary": "outline-secondary",
};

export default function AppButton({
  variant = "primary",
  action = false,
  className,
  size,
  ...props
}: AppButtonProps) {
  return (
    <Button
      variant={variantMap[variant]}
      size={size ?? (variant === "search" ? "search" : "action")}
      className={cn(action && "flex shrink-0 gap-1", className)}
      {...props}
    />
  );
}
